export enum ShopBudgetValues {
  Cheap = 'CHEAP',
  Moderate = 'MODERATE',
  Expensive = 'EXPENSIVE',
}
